




































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { pagination, loadingCatch, loading } from "@root/lib/decorator";

const Root = namespace("root");
// const order = namespace("order");
const importX = namespace("import");

@Component
@pagination("queryImportDetail", {
  pageSize: 5
})
@loading()
export default class ImportDialog extends Vue {
  @Prop({ required: true }) detailData: any;
  @Prop({ required: true }) fileCode: String;

  @importX.Action queryImportFileErrorInfo;

  private dialogTableVisible = false;
  private dataList = [];
  private detailsData = null;
  private resultInfo = null;
  private infoLoading = false;

  @Watch("detailData")
  onDetailDataChange(val) {
    if (val) {
      this.detailsData = { ...val };
      this.resultInfo = {
        errorCount: val.errorCount || 0,
        successCount: val.successCount || 0,
        totalCount: val.totalCount || 0,
        createTime: val.createTime || "",
        name: val.name || ""
      };
      this.queryImportDetail();
    }
  }

  async queryImportDetail() {
    const { pageSize, pageNum, detailsData } = this as any;
    const { importNo } = detailsData;

    let fetchData = {
      input: {
        pageSize,
        pageNum
      },
      fileCode: this.fileCode
    };
    try {
      this.infoLoading = true;
      let { data = [], total } = await this.queryImportFileErrorInfo(fetchData);
      (this as any).total = total;
      this.dataList = data;
    } catch (error) {
      console.log(error);
      this.dataList = [];
    } finally {
      this.infoLoading = false;
    }
  }
}
